import { render, staticRenderFns } from "./MainTour.vue?vue&type=template&id=24149212&scoped=true&"
import script from "./MainTour.vue?vue&type=script&lang=js&"
export * from "./MainTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24149212",
  null
  
)

export default component.exports